var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    [
      _c("PageHeader", { attrs: { title: _vm.name } }),
      _vm._v(" "),
      _c(
        "Subheader",
        { attrs: { title: "Map Layer List", "no-search": "" } },
        [
          _vm.newMapServiceConfigs.length != 0
            ? _c(
                "v-btn",
                {
                  attrs: { dark: "", color: "success" },
                  on: {
                    click: function ($event) {
                      _vm.showAddDialog = true
                    },
                  },
                },
                [
                  _c("v-icon", { staticClass: "mr-1" }, [_vm._v("add")]),
                  _vm._v(_vm._s(_vm.$t("Button.Add")) + "\n    "),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.newMapServiceConfigs.length == 0
            ? _c(
                "v-btn",
                {
                  attrs: { dark: "", color: "success" },
                  on: {
                    click: function ($event) {
                      _vm.showAddConfirmDialog = true
                    },
                  },
                },
                [
                  _c("v-icon", { staticClass: "mr-1" }, [_vm._v("add")]),
                  _vm._v(
                    _vm._s(_vm.$t("Button.GenerateDefaultLayers")) + "\n    "
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-card",
        [
          _c(
            "v-card-text",
            [
              _c("v-data-table", {
                attrs: {
                  headers: _vm.headers,
                  items: _vm.newMapServiceConfigs,
                },
                scopedSlots: _vm._u([
                  {
                    key: "items",
                    fn: function (props) {
                      return [
                        _c("td", [_vm._v(_vm._s(props.item.LayerName))]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-xs-left" }, [
                          _vm._v(_vm._s(props.item.DisplayName)),
                        ]),
                        _vm._v(" "),
                        _c(
                          "td",
                          { staticClass: "text-xs-center" },
                          [
                            _c(
                              "v-icon",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: props.item.ShowOnLoad,
                                    expression: "props.item.ShowOnLoad",
                                  },
                                ],
                                attrs: { color: "success" },
                              },
                              [_vm._v("check")]
                            ),
                            _vm._v(" "),
                            _c(
                              "v-icon",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: !props.item.ShowOnLoad,
                                    expression: "!props.item.ShowOnLoad",
                                  },
                                ],
                                attrs: { color: "delete" },
                              },
                              [_vm._v("close")]
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-xs-left" }, [
                          _vm._v(_vm._s(props.item.Ordinal)),
                        ]),
                        _vm._v(" "),
                        _c(
                          "td",
                          { staticClass: "text-xs-right" },
                          [
                            _c(
                              "v-btn",
                              {
                                attrs: { dark: "", color: "warning" },
                                on: {
                                  click: function ($event) {
                                    return _vm.gotoEdit(props.item)
                                  },
                                },
                              },
                              [
                                _c("v-icon", { staticClass: "mr-1" }, [
                                  _vm._v("edit"),
                                ]),
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.$t("Button.Edit")) +
                                    "\n            "
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "v-btn",
                              {
                                attrs: {
                                  dark: "",
                                  color: "error",
                                  disabled: !_vm.deleteable(
                                    props.item.LayerName
                                  ),
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.showDeleteMapLayer(props.item)
                                  },
                                },
                              },
                              [
                                _c("v-icon", { staticClass: "mr-1" }, [
                                  _vm._v("delete_forever"),
                                ]),
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.$t("Button.Delete")) +
                                    "\n            "
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { persistent: "", "max-width": "400px" },
          model: {
            value: _vm.showAddConfirmDialog,
            callback: function ($$v) {
              _vm.showAddConfirmDialog = $$v
            },
            expression: "showAddConfirmDialog",
          },
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-toolbar",
                { attrs: { dense: "", dark: "", color: "secondary" } },
                [
                  _c("v-toolbar-title", [_vm._v("Generate Default Layers")]),
                  _vm._v(" "),
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { icon: "", dark: "" },
                      on: {
                        click: function ($event) {
                          _vm.showAddConfirmDialog = false
                        },
                      },
                    },
                    [_c("v-icon", [_vm._v("close")])],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("v-card-text", [
                _vm._v(
                  "Tenant does not have any map layers. Do you want to generate the default basemap and satelite image\n        map layers?"
                ),
              ]),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "success" },
                      on: {
                        click: function ($event) {
                          return _vm.addDefaultLayer()
                        },
                      },
                    },
                    [
                      _c("v-icon", [_vm._v("done")]),
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("Button.Save")) +
                          "\n        "
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { outline: "", color: "secondary" },
                      on: {
                        click: function ($event) {
                          _vm.showAddConfirmDialog = false
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("Button.Close")))]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { persistent: "", "max-width": "800px" },
          model: {
            value: _vm.showAddDialog,
            callback: function ($$v) {
              _vm.showAddDialog = $$v
            },
            expression: "showAddDialog",
          },
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-toolbar",
                { attrs: { dense: "", dark: "", color: "primary" } },
                [
                  _c("v-toolbar-title", [_vm._v("Add A New Map Layer")]),
                  _vm._v(" "),
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { icon: "", dark: "" },
                      on: {
                        click: function ($event) {
                          return _vm.close()
                        },
                      },
                    },
                    [_c("v-icon", [_vm._v("close")])],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card-text",
                [
                  _c(
                    "v-layout",
                    { attrs: { row: "", wrap: "" } },
                    [
                      _c(
                        "v-flex",
                        { attrs: { xs12: "", "pa-3": "" } },
                        [
                          _c("v-text-field", {
                            attrs: { label: "Name" },
                            model: {
                              value: _vm.addMapLayerData.LayerName,
                              callback: function ($$v) {
                                _vm.$set(_vm.addMapLayerData, "LayerName", $$v)
                              },
                              expression: "addMapLayerData.LayerName",
                            },
                          }),
                          _vm._v(" "),
                          _c("v-text-field", {
                            attrs: { label: "DisplayName" },
                            model: {
                              value: _vm.addMapLayerData.DisplayName,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.addMapLayerData,
                                  "DisplayName",
                                  $$v
                                )
                              },
                              expression: "addMapLayerData.DisplayName",
                            },
                          }),
                          _vm._v(" "),
                          _c("v-switch", {
                            attrs: {
                              label: `ShowLoading : ${_vm.addMapLayerData.ShowOnLoad.toString()}`,
                            },
                            model: {
                              value: _vm.addMapLayerData.ShowOnLoad,
                              callback: function ($$v) {
                                _vm.$set(_vm.addMapLayerData, "ShowOnLoad", $$v)
                              },
                              expression: "addMapLayerData.ShowOnLoad",
                            },
                          }),
                          _vm._v(" "),
                          _c("v-select", {
                            attrs: { items: _vm.getOrdinal, label: "Ordinal" },
                            model: {
                              value: _vm.addMapLayerData.Ordinal,
                              callback: function ($$v) {
                                _vm.$set(_vm.addMapLayerData, "Ordinal", $$v)
                              },
                              expression: "addMapLayerData.Ordinal",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "success" },
                      on: {
                        click: function ($event) {
                          return _vm.addNewMapLayer()
                        },
                      },
                    },
                    [
                      _c("v-icon", [_vm._v("done")]),
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("Button.Save")) +
                          "\n        "
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { outline: "", color: "secondary" },
                      on: {
                        click: function ($event) {
                          return _vm.close()
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("Button.Close")))]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "500" },
          model: {
            value: _vm.deleteDialog,
            callback: function ($$v) {
              _vm.deleteDialog = $$v
            },
            expression: "deleteDialog",
          },
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-toolbar",
                { attrs: { dark: "", color: "primary" } },
                [
                  _c("v-toolbar-title", [_vm._v("Delete Map Layer")]),
                  _vm._v(" "),
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { icon: "" },
                      on: {
                        click: function ($event) {
                          _vm.deleteDialog = false
                        },
                      },
                    },
                    [_c("v-icon", [_vm._v("close")])],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("v-card-text", [
                _vm._v("Are you sure , delete this map layer ?"),
              ]),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { dark: "", color: "error" },
                      on: {
                        click: function ($event) {
                          return _vm.agreeDelete()
                        },
                      },
                    },
                    [
                      _c("v-icon", { staticClass: "mr-1" }, [
                        _vm._v("delete_forever"),
                      ]),
                      _vm._v("delete\n        "),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { outline: "", color: "secondary" },
                      on: {
                        click: function ($event) {
                          _vm.deleteDialog = false
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("Button.Cancel")))]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-snackbar",
        {
          staticStyle: { "text-align": "center" },
          attrs: { color: _vm.snackColor, timeout: null, top: "" },
          model: {
            value: _vm.snackbar,
            callback: function ($$v) {
              _vm.snackbar = $$v
            },
            expression: "snackbar",
          },
        },
        [
          _vm._v("\n    " + _vm._s(_vm.snackMessage) + "\n    "),
          _c(
            "v-btn",
            {
              attrs: { dark: "", flat: "" },
              nativeOn: {
                click: function ($event) {
                  $event.stopPropagation()
                  $event.preventDefault()
                  _vm.snackbar = false
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("Button.Close")))]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("ErrorDialog", {
        attrs: { data: _vm.errorDialog.data, title: _vm.errorDialog.title },
        model: {
          value: _vm.errorDialog.show,
          callback: function ($$v) {
            _vm.$set(_vm.errorDialog, "show", $$v)
          },
          expression: "errorDialog.show",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }